// HeroBanner2.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Contours from './Contours';
import './HeroBanner.css';

const HeroBanner = () => {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="hero-contours">
        <Contours />
      </div>
      <div className="wrap hero-inner">
        <span className="eyebrow">Thinking · Actions · Innovations</span>
        <h1 className="hero-title">
          Sustainability,
          <br />
          <em>tuned</em> into everything.
        </h1>
        <p className="hero-lede">
          We bring sustainability into thinking, actions, and innovations —
          helping organizations and people build safer, people-first
          ecosystems with data, AI, governance technologies, and products
          that nurture a sustainable mind.
        </p>
        <div className="hero-actions">
          <button className="btn btn-solid" onClick={() => navigate('/solutions')}>
            Explore our solutions <ArrowRight size={17} />
          </button>
          <button className="btn btn-ghost" onClick={() => navigate('/about')}>
            Who we are
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
